import { type Bridge, createBridge } from "#bridge/createBridge";

declare global {
	interface Window {
		/** Same instance as the package `bridge` singleton */
		InnoSdk?: Bridge;
	}
}

/**
 * Default ready-to-use bridge singleton.
 * Import on a site and talk to the Android wrapper (WebView / TWA).
 *
 * Also exposed as `window.InnoSdk` in the browser.
 *
 * @example
 * import { bridge } from "@innoclouds/sdk";
 *
 * bridge.on("backPressed", () => history.back());
 * bridge.emit("ready", { app: "qr-menu", version: "1.0.0" });
 * const info = await bridge.request("getInfo", null);
 */
export const bridge = createBridge();

if (typeof window !== "undefined") {
	window.InnoSdk = bridge;
}
